<template>
    <li @mouseover="lazyLoadContent($event.target)">
        <div class="title" ref="projectsTitle">
            <a :href="'#' + toKebab(project.title)" 
                @focus="lazyLoadContent($event.target)"
                @click="onClick($event)"
                tabindex="0">
                    <h3>{{project.title}}</h3>
            </a>
            <button class="close" 
                    @click="onClick($event)"
                    :tabindex="isOpen ? 0 : -1">
                <img :src="require(`../assets/close.svg`)" :alt="`Close ${project.title}`" />
            </button>
        </div>
        <div class="details" :class="project.layoutStyle ? 'layout-' + project.layoutStyle : ''">
            <div class="description">
                <div v-for="subsection in project.description" :key="subsection.id">
                    <h4 v-if="subsection.title" v-html="subsection.title"></h4>
                    <h5 v-if="subsection.subtitle" v-html="subsection.subtitle"></h5>
                    <p v-for="paragraph in subsection.text" :key="paragraph.id" v-html="paragraph"></p>
                </div>
                <a v-if="project.link" class="live-link" :href="project.link" rel="noopener" target="_blank">See it Live</a>
            </div>
            <image-gallery 
                :content="project.images" 
                :isOpen="isOpen"
                :liIndex="liIndex"/>
        </div>
    </li>
</template>

<script>

import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import ImageGallery from '../components/ImageGallery.vue'
import { SplitText } from "gsap/SplitText.js";


export default {
  name: 'ProjectsListItem',
  components: {
    ImageGallery
  },
  props: ['project', 'liIndex'],
  data() {
    return {
      splitText: null,
      isOpen: false,
      hasEmbed: false
    };
  },
  methods: {
    lazyLoadContent(target) {
        let li = target.closest("li");
        let items = li.querySelectorAll(".lazy")
        items.forEach((item)=> {
            if(item.hasChildNodes()) {
                item.childNodes.forEach((source)=> {
                    let src =  source.getAttribute("data-src");
                    source.setAttribute("src", src);
                })
                item.load();
                item.classList.remove("lazy");
            }
            else {
                let src =  item.getAttribute("data-src");
                item.setAttribute("src", src);
                item.classList.remove("lazy");
            }
        })
    },
    onClick(e) {
        e.preventDefault();
        this.isOpen = true
        this.$emit("openListItem", e);
    },
  },
  mounted() {
    document.fonts.ready.then(() => { 
        if (this.isMobile()) {
            this.splitText = new SplitText("#project-links li .title h3", {type: "lines", linesClass: "mobile-line"})
        }
        ScrollTrigger.addEventListener("refreshInit", ()=> {
            if (this.splitText != null) {
                this.splitText.revert();
                if (this.isMobile()) this.splitText.split()
            } else if (this.isMobile()) { this.splitText = new SplitText("#project-links li .title h3", {type: "lines", linesClass: "mobile-line"})}
            else { this.splitText = null;}
        })
    });
  }
}
</script>

<style lang="less" >
#project-links {
    li {
        padding-top: 14px;
        position: relative;
        line-height: 0;
        width: 100%;
        @media (min-width: 400px) {
            padding-top: 12px;
        }
        @media (min-width: 1200px) {
            padding-top: 20px;
        }
        &.active .title {
            a, a:hover {
                pointer-events: none;
                h3{ color: #ff779c; }
                &:before, &:after, .mobile-line:before { width: 0%; }
            }
        }
        &.showDetails {
            overflow: visible;
            .details {
                pointer-events: all;
                visibility: visible;
                position: relative;
            }
            .details p a {pointer-events: all;}
            .title .close {
                height: 2.5em;
            }
        }
        .title {
            display: flex;
            position: relative;
            justify-content: space-between;
            @media (min-width: 400px) {justify-content: flex-start;}
            a {
                font-family: 'Righteous'; 
                color: #5934B4;
                position: relative;
                overflow: visible;
                text-decoration: none;
                @media (min-width: 800px) { white-space: nowrap; }
                &:before, &:after, .mobile-line:before {
                    content: none;
                    background: #A5A5FF;
                    display: block;
                    position: absolute;
                    height: 8px;
                    width: 103%;
                    left: 50%;
                    bottom: 0;
                    transform: translateX(-50%) translateZ(0);
                    transform-origin: left center;
                    z-index: -1;
                    @media (min-width: 800px) {
                        content: ''; 
                    }
                }
                &:after {
                    background: #9EFFED;
                    transform: translateX(-50%) scaleX(0) translateZ(0);
                    transform-origin: left center;
                    transition: transform .25s cubic-bezier(0, 0.55, 0.45, 1);
                }
                &:hover {
                    cursor: pointer;
                    outline: none;
                    &:after { transform: translateX(-50%) scaleX(1) translateZ(0); }
                }
                &:focus {
                    outline: none;
                    &:after, &:before { display: none; }
                }
                .mobile-line{
                    position: relative;
                    display: inline-block !important;
                    &:before { content: ''; }
                    &:after { content: none; }
                }
            }
            h3 {
                display: inline; 
                margin: 0;
                font-size: 2.3em;
                line-height: 1.15em;
                //margin-right: 2.5em;
                @media (min-width: 400px) { 
                    font-size: 2em; 
                    line-height: 1em;
                    margin-right: 0;
                }
                @media (min-width: 1200px) { font-size: 2.3em;}
            }
            .close {
                display:block;
                position: absolute;
                margin-left: 15px;
                top: 0;
                transform: translateX(-.625em) translateY(-2.75em) translateZ(0);
                width: 2.5em;
                height: 0px;
                background: rgba(0,0,0,0);
                border: none;
                opacity: 0;
                visibility: hidden;
                outline: none;
                border-radius: 50%;
                padding: 0;
                right: 0;
                align-self: center;
                    @media (min-width: 400px) { 
                    transform: none;
                    top: unset;
                    display:inline;
                    position: relative;
                    right: auto;
                } 
                &:hover { cursor: pointer;}
            }
        }
        .details {
            display: flex;
            opacity: 0;
            pointer-events: none;
            position: absolute;
            padding: 10px 0 25px 1%;
            align-items: center;
            flex-direction: column;
            visibility: hidden;
            @media (min-width: 800px) {
                flex-direction: row;
                padding: 15px 0px 25px 0px;
            }
            &.layout-column {
                flex-direction: column; 
                align-items: start;
                @media (min-width: 800px) {
                    .description, .images { width: 100%; max-width: 650px;}
                    .images { margin-left: 0; margin-top: 20px;}
                }
            }
            h4 {
                color: #ff779c;
                font-size: 2em;
                font-family: 'Righteous'; 
                margin-top: 1em;
                margin-bottom: 0;
                line-height: 1em;
                @media (min-width: 400px) {
                    font-size: 1.7em;
                }
                @media (min-width: 400px) {
                    font-size: 1.5em;
                }
            }
            p {
                color: #ffb0f4;
                font-size: 1.6em;
                letter-spacing: .04em;
                line-height: 1.6em;
                margin-bottom: 0;
                margin-top: .8em;
                &:first-of-type { margin-top: .3em; }
                @media (min-width: 400px) {
                    font-size: 1em;
                    margin-top: .8em;
                }
                a{ 
                    color: inherit; 
                    font-family: inherit; 
                    font-weight: inherit;
                    pointer-events: none;
                }
            }
            .live-link {
                display: inline-flex;
                text-decoration: none;
                padding: 8px 20px;
                border-radius: 8px;
                color: #ff779c;
                border: #9fffee 2px solid;
                font-size: 1.2em;
                line-height: 1.2em;
                margin-top: 20px;
                & + .live-link { margin-top: 15px;}
                &:after {
                    content: url('~@/assets/arrow-right_teal.svg');
                    width: 30px;
                    height: auto;
                    display: inline-block;
                    color: #9fffee; 
                    margin-left: 10px;
                    align-self: center;
                    transition: margin-left 0.2s cubic-bezier(0, 0.55, 0.45, 1);
                }
                &:hover:after {
                    margin-left: 25px;
                }
            }
            .description, .images { width: 100%; }
            @media (min-width: 800px) {
                .description { width: 40%}
                .images { width: 60%}
            }
        }
    }
}
</style>
